export const namespace = 'uptakeInsights/';

export const UptakeInsightsGetters = {
  GET_UNIT_UPTAKE_INSIGHTS: namespace + 'getUnitUptakeInsights',
  GET_SHOW_INSIGHTS: namespace + 'getShowInsights'
};

export const UptakeInsightsActions = {
  SEARCH_UPTAKE_INSIGHTS: namespace + 'searchUptakeInsights',
  UPDATE_INSIGHT_STATUS: namespace + 'updateInsightStatus',
  FETCH_UNIT_UPTAKE_INSIGHTS: namespace + 'fetchUnitUptakeInsights',
  ADD_UPTAKE_INSIGHTS_TO_SO: namespace + 'addUptakeInsightsToSO'
};

export const UptakeInsightsMutations = {
  RESET_STATE: namespace + 'resetState',
  SET_UPTAKE_INSIGHTS_SEARCH_RESULTS: namespace + 'setUptakeInsightsSearchResults',
  SET_UNIT_UPTAKE_INSIGHTS: namespace + 'setUnitUptakeInsights',
  SET_JOB_PROPERTY: namespace + 'setJobProperty',
  SET_SELECTED_INSIGHT_ID: namespace + 'setSelectedInsightId',
  SET_SHOW_INSIGHTS: namespace + 'setShowInsights'
};
